// extracted by mini-css-extract-plugin
module.exports = {"heading":"Formulario_heading__-Sbjv","buscador":"Formulario_buscador__23FU4","btn-block":"Formulario_btn-block__3EAyR"};